module.exports = __webpack_public_path__ + "img/advisory.a4a9f387.png";